import React, {createContext, useEffect, useState} from "react"
import {useInterval} from "../hooks"

import ShelfApi from "~/utils/ShelfApi.js"

export const ShoppingCartContext = createContext()

export const ShoppingCartProvider = ({children}) => {
  const [shoppingCart, setShoppingCart] = useState([])
  const [archivedShoppingCarts, setArchivedShoppingCarts] = useState([])

  useEffect(() => {
    updateShoppingCart()
  }, [])

  useInterval(() => {
    if (process.env.DEACTIVATE_SHOPPING_CART_REFRESH) {
      console.log("Shopping cart auto-refresh deactivated...")
      return
    }
    updateShoppingCart()
  }, parseInt(5000))

  const updateShoppingCart = () => {
    ShelfApi("shopping_carts")
      .then(res => {
        const activeShoppingCarts =
          res.data.items.filter(s => s.ordered_at === null)[0] || []
        const closedShoppingCarts =
          res.data.items.filter(s => s.ordered_at !== null) || []

        setShoppingCart(activeShoppingCarts)
        setArchivedShoppingCarts(closedShoppingCarts)
      })
      .catch(error => {
        console.error("Failed to load shopping cart!")
        console.error(error)
      })
  }

  return (
    <ShoppingCartContext.Provider
      value={{shoppingCart, archivedShoppingCarts, updateShoppingCart}}
    >
      {children}
    </ShoppingCartContext.Provider>
  )
}



// WEBPACK FOOTER //
// ./src/context/ShoppingCartContext.js